import { ReactNode, useState } from "react";
import { useUser } from "@hooks/useUser";
import { useLogout } from "@hooks/useLogout";
import { Menu } from "@design-system/Menu/Menu.lib";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { UserDropdownHeader } from "./UserDropdownHeader";
import styles from "./UserDropdown.module.scss";

interface UserDropdownProps {
    items: ReactNode;
}

export const UserDropdown: React.FC<UserDropdownProps> = ({ items }) => {
    const [open, setOpen] = useState(false);
    const user = useUser();
    const logout = useLogout();

    if (!user) {
        return null;
    }

    return (
        <Menu.Root
            open={open}
            onOpenChange={setOpen}
            align="end"
            classNames={{ popup: styles.menuPopup }}
            trigger={
                <button type="button" className={styles.triggerButton}>
                    <UserAvatar
                        user={user}
                        size="md"
                        className={styles.avatar}
                    />
                </button>
            }
        >
            <UserDropdownHeader user={user} />
            {items ? (
                <>
                    <Menu.Separator />
                    {items}
                </>
            ) : null}
            <Menu.Separator />
            <Menu.Item onClick={logout}>Log out</Menu.Item>
        </Menu.Root>
    );
};
